<template>
  <v-card class="d-flex align-center justify-center pa-5 tournament-post-start-registration" outlined
    style="background-color: rgba(0,0,0,0); min-height: 70vh;">
    <v-container fluid>
      <v-overlay :dark="false" absolute v-model="showRegistrationModal">
        <TournamentRegisterCollapsed />
      </v-overlay>
      <div class="d-flex justify-center">
        <v-img class="mb-5" position="center center"
          src="https://hub.swiset.com/wp-content/uploads/2021/01/Tournaments-Ranking-Swiset.png" max-width="91px" contain />
      </div>
      <div>
        <h1 class="text-center">{{ $t('tournamentInProgress') }}</h1>
        <h3 class="text-center">{{ $t('lateRegistrationAvailable') }}</h3>
        <p class="text-center mt-4 registration-deadline">
          {{ $t('registrationDeadline', { days: remainingDays, hours: remainingHours }) }}
        </p>
        <div v-if="!iAmParticipant && canIRegister" class="mt-5 text-center">
          <v-btn class="button-register" @click="openRegistration">
            {{ $t('registerNow') }} <v-icon class="ml-2" color="white" small>fa-user-plus</v-icon>
          </v-btn>
        </div>
        <div v-else-if="iAmParticipant" class="mt-5 text-center">
          <p class="already-registered">{{ $t('alreadyRegistered') }}</p>
        </div>
      </div>
    </v-container>
  </v-card>
</template>

<script>
import TournamentRegisterCollapsed from "@/views/Tournament/components/TournamentRegisterCollapsed";

export default {
  name: "TournamentPostStartRegistration",
  components: { TournamentRegisterCollapsed },
  props: {
    iAmParticipant: Boolean,
    daysPostRegister: Number,
    tournamentStartTime: String
  },
  data() {
    return {
      canIRegister: false,
      showRegistrationModal: false,
      remainingDays: 0,
      remainingHours: 0
    };
  },
  mounted() {
    this.init();
    this.calculateRemainingTime();
  },
  watch: {
    '$store.state.tournament': function () {
      this.init();
      this.calculateRemainingTime();
    },
    iAmParticipant() {
      this.verifyCanIRegister();
    }
  },
  methods: {
    init() {
      this.verifyCanIRegister();
    },
    verifyCanIRegister() {
      let visibility = this.$store.state.tournament.tournamentSettings.tournamentVisibility;
      let isClubMember = this.$store.state.clubMember !== null && 
        this.$store.state.tournament.tournamentOrganizerId === this.$store.state.clubMember.club.id;
      let inviteOnly = this.$store.state.tournament.inviteOnly;
      
      // Check if user can register (same logic as TournamentNotStarted)
      this.canIRegister = !this.iAmParticipant && 
        !inviteOnly && 
        (visibility === 'PUBLIC' || (visibility === 'PRIVATE' && isClubMember));
    },
    openRegistration() {
      // Show the registration modal when button is clicked
      this.showRegistrationModal = true;
    },
    calculateRemainingTime() {
      if (!this.daysPostRegister || !this.tournamentStartTime) {
        return;
      }
      
      const startDate = new Date(this.tournamentStartTime);
      const registrationEndDate = new Date(startDate.getTime() + (this.daysPostRegister * 24 * 60 * 60 * 1000));
      const now = new Date();
      
      const timeDiff = registrationEndDate - now;
      
      if (timeDiff > 0) {
        this.remainingDays = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
        this.remainingHours = Math.floor((timeDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      } else {
        this.remainingDays = 0;
        this.remainingHours = 0;
      }
    }
  }
}
</script>

<style lang="scss">
.tournament-post-start-registration {
  h1 {
    font-size: 28px;
    font-weight: bold;
    color: var(--v-mainBlack-base);
    margin-bottom: 10px;
  }
  
  h3 {
    font-size: 18px;
    color: #666;
    margin-bottom: 20px;
  }
  
  .registration-deadline {
    font-size: 16px;
    color: #FF8933;
    font-weight: 500;
  }
  
  .button-register {
    background-color: var(--v-mainGreen-base) !important;
    color: #ffffff !important;
    padding: 10px 30px;
    font-size: 16px;
    font-weight: 500;
  }
  
  .already-registered {
    font-size: 16px;
    color: var(--v-mainGreen-base);
    font-weight: 500;
  }

  @media (max-width: 1290px) {
    h1 {
      font-size: 22px;
    }

    h3 {
      font-size: 16px;
    }
    
    .registration-deadline {
      font-size: 14px;
    }
  }
}
</style>